module.exports = __webpack_public_path__ + "img/active-d.99785c7d.png";